import React from 'react';
import './KpiStrip.css';
import Sparkline from './Sparkline';

function formatGross(gross) {
  const n = Number(gross) || 0;
  const dollars = Math.floor(n).toLocaleString('en-US');
  const cents = (n - Math.floor(n)).toFixed(2).slice(1); // ".54"
  return (
    <>
      ${dollars}<span className="mi-kpi-unit">{cents}</span>
    </>
  );
}

function formatSellThroughLine(kpis) {
  const pct = kpis.sell_through_pct ?? 0;
  const remaining = (kpis.remaining ?? 0).toLocaleString();
  return `${pct}% sell-through · ${remaining} to go`;
}

const KpiStrip = ({ kpis }) => {
  if (!kpis) return null;
  return (
    <div className="mi-kpi-strip">
      <div className="mi-kpi">
        <div className="mi-kpi-label">Gross</div>
        <div className="mi-kpi-value">{formatGross(kpis.gross)}</div>
      </div>
      <div className="mi-kpi">
        <div className="mi-kpi-label">Tickets sold</div>
        <div className="mi-kpi-value">
          {(kpis.tickets_sold ?? 0).toLocaleString()}
          <span className="mi-kpi-unit">/ {(kpis.capacity ?? 0).toLocaleString()}</span>
        </div>
        <div className="mi-kpi-sub">{formatSellThroughLine(kpis)}</div>
      </div>
      <div className="mi-kpi">
        <div className="mi-kpi-label">Sell-through</div>
        <div className="mi-kpi-value">
          {(kpis.sell_through_pct ?? 0)}<span className="mi-kpi-unit">%</span>
        </div>
        <div className="mi-kpi-sub">{(kpis.remaining ?? 0).toLocaleString()} to go</div>
      </div>

      {kpis.daily_pace != null && (
        <div className="mi-kpi">
          <div className="mi-kpi-label">Daily pace (7d avg)</div>
          <div className="mi-kpi-value">{kpis.daily_pace}<span className="mi-kpi-unit">tix / day</span></div>
        </div>
      )}
      {kpis.weekly_pace != null && (
        <div className="mi-kpi">
          <div className="mi-kpi-label">Weekly pace</div>
          <div className="mi-kpi-value">{kpis.weekly_pace}<span className="mi-kpi-unit">tix / wk</span></div>
          <Sparkline values={kpis.weekly_pace_spark || []} />
        </div>
      )}
      {kpis.forecast != null && (
        <div className="mi-kpi">
          <div className="mi-kpi-label">Forecast finish</div>
          <div className="mi-kpi-value">~{kpis.forecast.toLocaleString()}</div>
          {kpis.forecast_data_sufficient === false && (
            <div className="mi-kpi-sub">Insufficient data — need 2+ days of sales</div>
          )}
          {kpis.forecast_revised_from != null && (
            <div className="mi-kpi-sub mi-kpi-sub-revised">
              revised from {kpis.forecast_revised_from.toLocaleString()} tix
            </div>
          )}
        </div>
      )}
      {kpis.pace_vs_comps != null && (
        <div className="mi-kpi">
          <div className="mi-kpi-label">Pace vs comps</div>
          <div className="mi-kpi-value">{kpis.pace_vs_comps}</div>
        </div>
      )}
    </div>
  );
};

export default KpiStrip;
